export default __webpack_public_path__ + "static/media/calendar-arrow-back.16d9e48c.svg";